import { forwardRef, memo } from 'react';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { ScheduleStepProps } from '../../config/schedule.types';
import { ScorecardStep as SharedScorecardStep } from '../../../components/ScorecardStep';
import { SCHEDULE_INTERVIEW_COPY } from '../../config/schedule.copy';

export const ScorecardStep = memo(
  forwardRef<StepFormApi, ScheduleStepProps>((props, ref) => (
    <SharedScorecardStep
      ref={ref}
      payloadRef={props.payloadRef}
      prefillVersion={props.prefillVersion}
      copy={SCHEDULE_INTERVIEW_COPY.scorecard}
      interviewPlan={props.interviewPlan}
    />
  ))
);

ScorecardStep.displayName = 'ScorecardStep';
